export default {
  sceneAttribute: 'シーンのプロパティ',
  endingScene: '終了シーン',
  sceneDesc:
    'プレイ完了率のトラッキングをするために、終了シーンを設定してください。',
  warnEnding: '最低でも1つの終了シーンを保持してください。',
  viewSetting: {
    single: '単一シーンビュー',
    story: 'ストーリーボードビュー',
    global: 'グローバルシーンビュー',
    play: 'ゲームプレイシーンビュー',
  },
  playScene: {
    title: 'ゲームプレイテンプレート',
    back: 'プロジェクト編集に戻る',
    create: 'ゲームプレイテンプレートの作成',
    none: '現在の素材にはゲームプレイテンプレートが使用されていません',
    errorMsg: 'サポートされていないファイルタイプが含まれています',
    action: {
      edit: 'ゲームプレイの編集',
      bind: 'シーンのバインド',
      unbind: 'シーンのバインドを解除',
      quick: 'クイックレイアウトの追加',
      back: '作品の編集に戻る',
      delete: '削除',
      componentSetting:
        'ここをクリックしてコンポーネントの設定にアクセスできます。',
    },
    unbind: '未バインド',
    need: 'クイックレイアウトが追加されていません',
    bindNote: 'バインド成功',
    unbindNote: 'バインド解除成功',
  },
  otherLayer: 'その他',
  globalScene: {
    edit: '編集に進む',
    title: 'グローバルシーン',
    settingTips: {
      title:
        'グローバル設定では、背景画像、背景色、BGM、多言語を設定することができます。また、グローバルシーンをデザインすることもでき、すべてのシーンに適用することができます。',
      name: 'グローバルシーンには、さまざまな画像、テキスト、効果音、エフェクトなどを追加することができます。1つの項目を変更するだけで、すべてのシーンのデザインが変更されます。',
    },
    isGlobal: {
      checkboxLabel: '有効にする',
    },
    globalIndex: {
      top: 'シーンの最初に配置',
      bottom: 'シーンの最後に配置',
    },
  },
}
